var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menubuilder__cselector" },
    [
      _c("h3", [_vm._v("Our Coffees")]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "menubuilder__coffeelist" },
        [
          _vm.selectedCoffees
            ? _vm._l(_vm.selectedCoffees, function (coffee, index) {
                return _c(
                  "li",
                  { key: index, staticClass: "menubuilder__coffee" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "ma__close",
                        on: {
                          click: function ($event) {
                            return _vm.$store.removeSelectedCoffee(coffee)
                          },
                        },
                      },
                      [_vm._v("×")]
                    ),
                    _vm._v(" "),
                    _c("h2", { domProps: { innerHTML: _vm._s(coffee.name) } }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "menubuilder__description",
                      domProps: { innerHTML: _vm._s(coffee.description) },
                    }),
                  ]
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.coffees && _vm.selectedCoffees.length < 2
            ? _c(
                "li",
                {
                  staticClass: "menubuilder__coffee menubuilder__coffee--add",
                  on: { click: _vm.toggleCoffeePopup },
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "Add the Matthew Algie coffee you serve (Max 2, " +
                        _vm._s(2 - _vm.selectedCoffees.length) +
                        " left)"
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            title: "Select a coffee you stock",
            isOpen: _vm.selectCoffeePopupOpen,
          },
          on: { toggle: _vm.toggleCoffeePopup },
        },
        [
          _c(
            "ul",
            { staticClass: "menubuilder__modallist" },
            _vm._l(_vm.availableCoffees, function (coffee, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: `${coffee === _vm.preselectedCoffee && "selected"}`,
                  on: {
                    click: function ($event) {
                      return _vm.preselectCoffee(coffee)
                    },
                  },
                },
                [
                  _c("h2", { domProps: { innerHTML: _vm._s(coffee.name) } }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "menubuilder__description",
                    domProps: { innerHTML: _vm._s(coffee.description) },
                  }),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              class: `menubuilder__addtomenu ${
                _vm.preselectedCoffee === undefined &&
                "menubuilder__addtomenu--disabled"
              }`,
              attrs: { disabled: _vm.preselectedCoffee === undefined },
              on: {
                click: function ($event) {
                  return _vm.selectCoffee()
                },
              },
            },
            [_vm._v("Add to menu")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "plus" }, [_c("span", [_vm._v("+")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/MenuBuilder/CoffeeSelector.vue